import Draft from "draft-js";
import convertToHtml from "draftjs-to-html";

export const getHtmlFromState = (state: Draft.EditorState) => {
  const rawContent = Draft.convertToRaw(state.getCurrentContent());
  return convertToHtml(
    rawContent,
    undefined,
    undefined,
    // Custom transform for user mentions
    (entityData, decoratedText: string) => {
      if (
        entityData.type === "USER_MENTION" &&
        typeof entityData.data?.userId === "string"
      ) {
        return `<a data-user-id="${entityData.data.userId}">${decoratedText}</a>`;
      }
      return decoratedText;
    },
  );
};
